import { LINKS } from './site'

export const autoLinks = [
  { label: 'Auto Glass', href: LINKS.auto },
  { label: 'Windshield Replacement', href: LINKS.windshield },
  { label: 'Windshield Chip Repair', href: LINKS.chip },
  { label: 'ADAS Calibration', href: LINKS.adas },
  { label: 'Emergency Auto Glass', href: LINKS.emergencyAuto },
]
export const residentialLinks = [
  { label: 'Residential Glass', href: LINKS.residential },
  { label: 'Glass vs Replacement Windows', href: '/replacementwindows.html' },
  { label: 'Window Glass', href: '/windowglass.html' },
  { label: 'Custom Mirrors', href: '/customglassmirrors.html' },
  { label: 'Glass Deck Railing', href: '/deckglass.html' },
]
export const areaLinks = [
  { label: 'Ann Arbor', href: '/glassannarbormichigan.html' },
  { label: 'Brighton', href: '/glassrepairbrighton.html' },
  { label: 'Commerce Township', href: '/glasscommercemichigan.html' },
  { label: 'Fenton', href: '/glassfentonmichigan.html' },
  { label: 'Fowlerville', href: '/glassfowlervillemichigan.html' },
  { label: 'Highland', href: '/glasshighlandmichigan.html' },
  { label: 'Howell', href: '/glassrepairhowellmichigan.html' },
  { label: 'Lansing', href: '/glassrepairlansingmichigan.html' },
  { label: 'Northville', href: '/glassnorthvillemichigan.html' },
  { label: 'Novi', href: '/glassnovimichigan.html' },
  { label: 'Pinckney', href: '/glasspinckneymichigan.html' },
  { label: 'Webberville', href: '/glasswebbervillemichigan.html' },
  { label: 'Williamston', href: '/glasswilliamstonmichigan.html' },
]
